import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  columns: [
    'status',
    'provider',
    'date',
    'patient',
    'case',
    'category',
    'total',
    'patient.phone',
    'session_type',
    'location',
    'comment',
    'actions',
  ],
};

const slice = createSlice({
  name: 'sessionTable',
  initialState,
  reducers: {
    setColumns: (state, action) => ({
      ...state,
      columns: action.payload || initialState.selectedColumns,
    }),
  }
});

export const {
    setColumns,
} = slice.actions;
    
  export default slice.reducer;